import React, { useEffect } from "react";
import { CommonService } from "../../services/common/common.service";
import { useTranslation } from "react-i18next";
import { TasksProvider } from "../../store";
import HeaderComponent from "../../components/header/header.component";
import "./ratings.page.scoped.sass";
import RatingsMob from "../../components/ratings-mob/ratings-mob.component";

export default function RatingsPage(props: any) {
  const { state: taskData } = props.location;
  const { recordTaskId } = props.match.params;
  return (
    <TasksProvider>
      <RatingsPageContent taskData={taskData} recordTaskId={recordTaskId} />
    </TasksProvider>
  );
}

export function RatingsPageContent(props: any) {
  const { recordTaskId, taskData } = props;
  const commonService = new CommonService();

  const [t] = useTranslation();

  useEffect(() => {
    const title = t("ratings");
    commonService.setTitle(title);
    // eslint-disable-next-line
  }, []);

  return (
    <div id="mobView">
      <HeaderComponent
        mobtitle="details"
        displayMenu={false}
        mobView={true}
        centered={true}
        layout={'half'}
      />
      <RatingsMob recordTaskId={recordTaskId} taskData={taskData} />
    </div>
  );
}
